export const lenisRef = { current: null };

export const scrollToId = (id) => {
    const target = document.getElementById(id);
    if (!target) return;
    if (lenisRef.current) {
        lenisRef.current.scrollTo(target, { offset: -72, duration: 1.4 });
    } else {
        target.scrollIntoView({ behavior: "smooth" });
    }
};
